module.exports = __webpack_public_path__ + "media/assets/images/plan03_label@2x-6ad01634fe9eff45a07ec4d38f307441.png";